import { Modal, ModalProps } from 'antd';
import ModalHeader from './ModalHeader';

type AntModalProps = {
  openModal: boolean;
  onCancel: () => void;
  title: string;
  width?: number;
  height?: number;
  children: React.ReactNode;
  footer?: ModalProps['footer'];
};

const AntModal = ({
  openModal,
  onCancel,
  title,
  width,
  height,
  children,
  footer,
}: AntModalProps) => {
  return (
    <Modal
      destroyOnClose
      open={openModal}
      onCancel={onCancel}
      title={<ModalHeader title={title} />}
      footer={footer || null}
      className="custom-modal"
      width={width || 650}
      centered
      bodyStyle={{
        maxHeight: height ?? 480,
        scrollBehavior: 'smooth',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '16px',
      }}
      // forceRender
      // confirmLoading
    >
      {children}
    </Modal>
  );
};

export default AntModal;
